<template>
  <b-modal
    ref="bmModal"
    :no-close-on-backdrop="true"
    :no-close-on-esc="true"
    :size="size"
    centered
    hide-header
    hide-footer
    @hidden="close">

    <div v-if="value">
      <a
        class="close-button"
        @click="close">
        <i class="material-icons">close</i>
      </a>

      <div class="mb-3">
        <div
          v-if="$slots.header"
          class="bm-modal-header px-3 px-md-4 mt-3">
          <slot name="header" />
        </div>

        <div class="px-3 px-md-4 mt-3 mt-md-4">
          <slot/>
        </div>

        <div
          v-if="$slots.buttons"
          class="text-center mt-3 mt-md-4">
          <slot name="buttons"/>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import bModal from 'bootstrap-vue/es/components/modal/modal';

export default {
  components: {
    bModal,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.open();
        } else {
          this.close();
        }
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      if (this.$refs.bmModal) {
        this.$refs.bmModal.show();
        this.$emit('input', true);
      } else {
        const self = this;
        setTimeout(() => self.open(), 100);
      }
    },
    close() {
      if (this.$refs.bmModal) {
        this.$refs.bmModal.hide();
        this.$emit('input', false);
      } else {
        const self = this;
        setTimeout(() => self.close(), 100);
      }
    },
  },
};
</script>

<style lang="scss">
@import "src/styles/_includes.scss";

.bm-modal-header {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-bottom: 0;
  }
}

.modal {
  .modal-content {
    border-radius: 0;

    .close-button {
      position: absolute;
      top: 0;
      right: 0;
      color: $text-muted;
      padding: 2rem 2rem 0.5rem 0.5rem;

      @include media-breakpoint-down(md) {
        padding: 1rem;
      }

      @include media-breakpoint-down(xs) {
        padding: 0.5rem;
      }

      @include transition();

      i {
        font-size: 2.25rem;
      }

      &:hover {
        color: $body-color;
      }
    }
  }
}

.modal-xl {
  @include media-breakpoint-down(lg) {
    max-width: calc(100% - (#{$spacer} * 2)) !important;
  }
  @include media-breakpoint-down(sm) {
    max-width: 100% !important;
  }
  @include media-breakpoint-up(xl) {
    max-width: 1200px !important;
  }
}
</style>
